import React from "react";
import { Navigate } from "react-router-dom";
import { DEFAULT_ADMIN_ROUTE } from "../features/admin/navigation/routes";
import { hasActiveSession } from "../services/auth";

const PublicOnlyRoute: React.FC<React.PropsWithChildren> = ({ children }) => {
  return hasActiveSession()
    ? <Navigate to={DEFAULT_ADMIN_ROUTE} replace />
    : <>{children}</>;
};

export default PublicOnlyRoute;
